import { Grid, Select } from '@material-ui/core';
import styled, { css } from 'styled-components';

import { HoverOptionItems } from './questionRow';

export const TabularGrid = styled(Grid)`
  padding: 1rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        cursor: pointer;
        background: ${(props) => props.theme.palette.background.blue.light.v2};
        ${HoverOptionItems} {
          visibility: visible;
        }
      }
    `};
`;

export const PaddedGrid = styled(Grid)`
  padding: 0 1rem 0 0;
`;

export const StyledSelect = styled(Select)`
  min-width: 75%;
  .MuiSelect-select {
    padding: 11px 32px 11px 0.8rem;
    font-size: 0.9rem;
  }
`;
